'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uses = exports.alignment = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _colors = require('HubStyleTokens/colors');

var _canReadText = require('../util/canReadText');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alignment = exports.alignment = {
  LEFT: 'left',
  RIGHT: 'right'
};

var uses = exports.uses = {
  INBOX: 'inbox',
  DEFAULT: 'default'
};

var propTypes = {
  align: _react.PropTypes.oneOf([alignment.LEFT, alignment.RIGHT]).isRequired,
  backgroundColor: _react.PropTypes.string,
  border: _react.PropTypes.string,
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  color: _react.PropTypes.string,
  isFirstInGroup: _react.PropTypes.bool.isRequired,
  isLastInGroup: _react.PropTypes.bool.isRequired,
  use: _react.PropTypes.oneOf([uses.INBOX, uses.DEFAULT]).isRequired
};

var defaultProps = {
  align: alignment.LEFT,
  isFirstInGroup: true,
  isLastInGroup: true,
  use: uses.DEFAULT
};

var ChatBubble = function (_Component) {
  _inherits(ChatBubble, _Component);

  function ChatBubble() {
    _classCallCheck(this, ChatBubble);

    return _possibleConstructorReturn(this, (ChatBubble.__proto__ || Object.getPrototypeOf(ChatBubble)).apply(this, arguments));
  }

  _createClass(ChatBubble, [{
    key: 'shouldUseLightLinkColor',
    value: function shouldUseLightLinkColor() {
      var backgroundColor = this.props.backgroundColor;


      return backgroundColor && !(0, _canReadText.canReadText)(backgroundColor, _colors.CALYPSO_DARK);
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var _props = this.props,
          align = _props.align,
          isLastInGroup = _props.isLastInGroup,
          isFirstInGroup = _props.isFirstInGroup,
          className = _props.className,
          use = _props.use;


      return (0, _classNames2.default)('chat-bubble', 'selenium-test-marker-chat-bubble', {
        'sender-text': align === alignment.RIGHT,
        'recipient-text': align === alignment.LEFT,
        'first-in-group': isFirstInGroup,
        'last-in-group': isLastInGroup,
        'override-default-link-color': this.shouldUseLightLinkColor(),
        'inbox-recipient-text': align === alignment.LEFT && use === uses.INBOX,
        'inbox-sender-text': align === alignment.RIGHT && use === uses.INBOX
      }, className);
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      var _props2 = this.props,
          backgroundColor = _props2.backgroundColor,
          border = _props2.border,
          color = _props2.color;


      if (!backgroundColor && !border && !color) {
        return null;
      }

      return { backgroundColor: backgroundColor, border: border, color: color };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.getClassName(), style: this.getStyle() },
        _react2.default.createElement(
          'div',
          { className: 'chat-bubble-content flex-column' },
          this.props.children
        )
      );
    }
  }]);

  return ChatBubble;
}(_react.Component);

ChatBubble.propTypes = propTypes;
ChatBubble.defaultProps = defaultProps;

exports.default = ChatBubble;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-messages/static-1.640/js/chat-message/ChatBubble.js
// module id = 155
// module chunks = 2 3